import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, InputAdornment, Radio, RadioGroup, Stack, TextField, Typography } from "@mui/material"
import { isDesktop } from "react-device-detect"
import { validateEmail, ValidateInt } from "../../../../core/validator/Validator"
import { domain, env, key } from "../../../../core/Env"
import { rqx } from "../../../../core/request/API"
import Gcash from "../../../../assets/images/logos/gcash.png"
import Ub from "../../../../assets/images/logos/ub.png"
import sha1 from "js-sha1"

export const FormSetup = ({info, tool_state, isAvailed}) => {
    const { __SESSION } = tool_state
    const history = useHistory()
    const [input, setInput] = useState({name: '', contact_no: '', email: '', with_voucher: false, voucher_code: '', payment_method: 'GCSH', error: false, confirmation: false, voucher_valid : false, btnLoader: false})
    const dlft_input = {name: '', contact_no: '', email: '', with_voucher: false, voucher_code: '', payment_method: 'GCSH', error: false, confirmation: false, voucher_valid : false, btnLoader: false}

    const handleChange = (e) => {
        const { name, value, checked } = e.target
        if (name === 'voucher_code') {
            const isValid = value.trim().toLowerCase() === info.data.voucher_code.toLowerCase();
            console.log(isValid)
            setInput((p) => (
                {...p, 'voucher_code' : value, 'voucher_valid' : isValid}
            ))
            return
        }
        if (name === 'with_voucher') {
            setInput((p) => (
                {...p, 'with_voucher' : checked, 'voucher_code': '', 'voucher_valid': false}
            ))
            return
        }
        setInput((p) => (
            {...p, [name] : value}
        ))
    }

    const handlePay = () => {
        // add validations for UBR HERE
        if (input.name.trim() === "" || input.contact_no.trim() === "" || input.email.trim() === "" || !validateEmail(input.email) || (input.with_voucher && (input.voucher_code.trim() === "" || !input.voucher_valid )) ) {
            setInput((p) => (
                {...p, error : true}
            ))
        }else{
            setInput((p) => (
                {...p, error : false, confirmation: true}
            ))
        }
    }
    
    const computationAmount = () => {
        let membership_fee;
        let discount_amount;
        if (info.data.fee_type === 2) {     
            if (info.data.voucher_code === "") {
                discount_amount = info.data.discount
                membership_fee = info.data.price
            }else{
                if (input.voucher_valid) {
                    discount_amount = info.data.discount
                    membership_fee = info.data.price
                }else{
                    membership_fee = info.data.regular_price
                }
            }
        }else{
            membership_fee = 0
        }
        return { membership_fee, discount_amount}
    }
    const handleConfirmation = async(type) => {
        setInput((p) => (
            {...p, btnLoader : true}
        ))
        let body;
        let x = await localStorage.getItem('membership');
        let urb_membership = null;

        try {
            if (x) {
                urb_membership = JSON.parse(x);
            }
        } catch (e) {
            console.error("Failed to parse membership from localStorage:", e);
        }

        const hasStoredMembership = (
            urb_membership &&
            Object.keys(urb_membership).length !== 0 &&
            tool_state.userId.data &&
            tool_state.userId.data !== 0
        );
        if (hasStoredMembership) {
            body = {
                id: urb_membership.id,
                fee_type: urb_membership.fee_type,
                amount: urb_membership.amount,
                user_id: tool_state.userId.data,
                full_name: urb_membership.name,
                contact_no: urb_membership.contact_no,
                email: urb_membership.email,
                voucher_code: urb_membership.voucher_code,
                company_name: urb_membership.company_name,
                payment_method: urb_membership.payment_method
            };
        } else {
            body = {
                id: info.data.id,
                fee_type: info.data.fee_type,
                amount: computationAmount().membership_fee,
                user_id: tool_state.userId.data,
                full_name: input.name,
                contact_no: input.contact_no,
                email: input.email,
                voucher_code: input.voucher_code,
                company_name: info.data.company_name,
                payment_method: input.payment_method
            };
        }
       
        if (__SESSION.data.ainfo === null || window.atob(__SESSION.data.ainfo.aid).split('_')[1] === '0' || tool_state.userId.data === 0) {
            const urb_membership = {
                id: info.data.id,
                amount: computationAmount().membership_fee,
                fee_type: info.data.fee_type,
                user_id: tool_state.userId.data,
                company_name: info.data.company_name,
                ...input
            }
            localStorage.setItem('membership', JSON.stringify(urb_membership))
            const s = {
                contact_info: {contact_num: input.contact_no},
                full_name: input.name,
                pcred: input.email,
                id: info.data.id,
                from: 'membership',
            } ;
            window.location.href = `${domain('pm').url}/sso/rqx?from=${key('tsa_key')}&callback=${env() === 'dev' || env() === 'local' || env() === 'sb' ? 'sandbox' : 'production'}&platform=personal&auth_type=registration&entry=ubr_profile&subcb=${window.btoa(JSON.stringify(s))}`
        }else{
            const res = await rqx.post(`<<tool>>/${env()}/membership/create`, body);
            if (res.message === 'success') {
                if (body.fee_type === 2) {
                    let payment_fee;
                    if (body.payment_method === 'GCSH') {
                        payment_fee = (computationAmount().membership_fee * 0.02) + 10
                    } else {
                        payment_fee = 10
                    }
    
                    let params = {
                        'merchantid': 'I4ONE2',
                        'txnid': (Math.random() + 1).toString(36).substring(7),
                        'amount': body.amount,
                        'ccy': 'PHP',
                        'description': `From Client: ${body.full_name}, Merchant: ${body.company_name}`,
                        'email': body.email,
                    }
                    let d = {...params, key: process.env.REACT_APP_DRAGONPAY_KEY }
                    let digest = ''
                    for (const i in d) {
                        if (digest === '') { digest = `${d[i]}` } else { digest = `${digest}:${d[i]}` }
                    }
                    let dfinal = {...params, 
                        'param1': JSON.stringify({cb:'membership', aid: body.user_id, payment_fee: payment_fee, 'payment_channel': body.payment_method === 'GCSH' ? 7 : 15 }), 
                        'param2': JSON.stringify({oid:res.order_id, payment_type: 1, membership_id: body.id, fee_type: body.fee_type }), digest: sha1(digest)
                    }
                    let subqsp = []
                    Object.keys(dfinal).map(k => subqsp.push(`${k}=${encodeURIComponent(dfinal[k])}`));
                    let qsp = `${subqsp.join('&')}`
                    const url = env() === 'prod' ? `https://gw.dragonpay.ph/Pay.aspx?${qsp}` : `https://test.dragonpay.ph/Pay.aspx?${qsp}`;
                    window.location.href = url;
                }else{
                    setInput(dlft_input)
                    history.push(`/psl/membership?steps=receipt&type=free&id=${window.btoa(info.data.id)}&order_id=${window.btoa(res.order_id)}`)
                }
            }
        }
        
    }
    
    const ubrFormSubmit = async() => {
        let x = await localStorage.getItem('membership');
        let urb_membership = null;

        try {
            if (x) {
                urb_membership = JSON.parse(x);
            }else{
                if (tool_state.userId.data !== 0) {
                    
                    setInput((p) => (
                        {...p, 
                            name: __SESSION.data.pinfo.length === 0 ? "" : `${__SESSION.data.pinfo?.[0]?.last_name || ""} ${__SESSION.data.pinfo?.[0]?.first_name || ""} ${__SESSION.data.pinfo?.[0]?.middle_name.length !== 0 ? "," : ""} ${__SESSION.data.pinfo?.[0]?.middle_name || ""}`,
                            contact_no: __SESSION.data.ainfo?.mobile_num || "",
                            email: __SESSION.data.ainfo?.email || "",
                        }
                    ))
                }
            }
        } catch (e) {
            console.error("Failed to parse membership from localStorage:", e);
        }

        const hasStoredMembership = (
            urb_membership &&
            Object.keys(urb_membership).length !== 0 &&
            tool_state.userId.data &&
            tool_state.userId.data !== 0
        );
        if (hasStoredMembership) {
            console.log('here')
            setInput((p) => (
                {...p, 
                    name: urb_membership.name, contact_no: urb_membership.contact_no, email: urb_membership.email, with_voucher: urb_membership.with_voucher, voucher_code: urb_membership.voucher_valid, payment_method: urb_membership.payment_method, error: urb_membership.error, confirmation: urb_membership.confirmation, voucher_valid : urb_membership.voucher_valid, btnLoader: true
                }
            ))
            if (!isAvailed) {
                await handleConfirmation('ubr')
            }else{
                setInput((p) => (
                    {...p, 
                        confirmation: false, btnLoader: false
                    }
                ))
                localStorage.setItem('membership', JSON.stringify(urb_membership))
            }
        }
    }
    
    useEffect(() => {
        // for ubr
        const checkUbr = async () => {
            if (__SESSION.data.ainfo !== null || window.atob(__SESSION.data.ainfo.aid).split('_')[1] !== '0' ) {
                await ubrFormSubmit();
            }
        }
        checkUbr()
        // eslint-disable-next-line
    },[])
    
    return (
        <>
            <Dialog open={true} fullScreen={!isDesktop ? true : false}>
                <Box height="100%" display="flex" flexDirection="column" className="overflowY">
                    <Box height="100%" p="1rem" display="flex" flexDirection="column" gap={isDesktop ? "2rem" : "1rem"} className="overflowY">
                        <Stack direction="row" justifyContent="center" alignItems="center">
                            <Typography fontSize={isDesktop ? 20 : 18} fontWeight={600}>
                                {info.data.name}
                            </Typography>
                        </Stack>
                        <Typography variant="subtitle1" fontWeight={600}>Member Details</Typography>
                        <Stack gap="1rem">
                            <Stack direction="row" alignItems="center">
                                <Stack direction="row" sx={{ minWidth: '7.5rem' }}>
                                    <Typography variant="body2" color="#1976D2">Name:</Typography>
                                    <Typography component="span" color="error">*</Typography>
                                </Stack>
                                {/* disabled={form.data.is_availed} className={classes.tf} variant="outlined" fullWidth value={form.data.name.value} error={form.data.name.stat} helperText={form.data.name.stat ? dfltForm.data.name.msg : ""} */}
                                <TextField name="name" size="small" fullWidth placeholder="Lastname Firstname, MI" onChange={handleChange} 
                                    value={input.name}
                                    error={input.error && input.name.trim() === ""}
                                    disabled={isAvailed}
                                />
                            </Stack>
                            <Stack direction="row" alignItems="center">
                                <Stack direction="row" sx={{ minWidth: '7.5rem' }}>
                                    <Typography variant="body2" color="#1976D2">Contact No.:</Typography>
                                    <Typography component="span" color="error">*</Typography>
                                </Stack>
                                {/* disabled={form.data.is_availed} className={classes.tfs} variant="outlined" fullWidth value={form.data.contact_no.value} onChange={handleChange}  error={form.data.contact_no.stat} helperText={form.data.contact_no.stat ? dfltForm.data.contact_no.msg : ""} */}
                                <TextField name="contact_no" size="small" fullWidth placeholder="9562749314" onChange={handleChange}
                                    InputProps={{ startAdornment: ( <InputAdornment position="start">
                                        <Typography align="left" ml="8px" sx={{ color: "#5B6167", fontSize: "14px" }}>+63</Typography>
                                    </InputAdornment> ) }}
                                    value={input.contact_no}
                                    error={input.error && input.contact_no.trim() === ""}
                                    onKeyDown={ValidateInt} 
                                    inputProps={{ maxLength: 10 }}
                                    disabled={isAvailed}
                                />
                            </Stack>
                            <Stack direction="row" alignItems="center">
                                <Stack direction="row" sx={{ minWidth: '7.5rem' }}>
                                    <Typography variant="body2" color="#1976D2">Email:</Typography>
                                    <Typography component="span" color="error">*</Typography>
                                </Stack>
                                <TextField name="email" size="small" fullWidth placeholder="email@gmail.com" onChange={handleChange} 
                                    value={input.email}
                                    error={input.error && (input.email.trim() === "" || !validateEmail(input.email))}
                                    helperText={input.error && (input.email.trim() === "" || !validateEmail(input.email)) && 'Invalid Email'}
                                    disabled={isAvailed}
                                />
                            </Stack>
                            <Stack direction="row" gap="1rem">
                                <Typography fontSize={12} fontWeight={600} sx={{ color: '#37474F' }}>Note:</Typography>        
                                <Typography fontSize={12} fontWeight={400} align="justify" sx={{ color: '#5B6167' }}>This email will serve as the login account. If you are registering on behalf of someone else, please enter their email address to ensure they can access their training on this platform</Typography>
                            </Stack>
                            {
                                info.data.fee_type === 2 && 
                                    <>
                                        {
                                            info.data.voucher_code !== "" &&
                                                <Stack direction="row" alignItems="baseline" gap="1rem">
                                                    <Stack direction="row" alignItems="center">
                                                        {/*  checked={form.data.with_voucher} disabled={form.data.is_availed} */}
                                                        <Checkbox name="with_voucher" checked={input.with_voucher} onChange={handleChange} disabled={isAvailed} />
                                                        <Typography variant="body2">Voucher Code</Typography>
                                                    </Stack>
                                                    {
                                                        input.with_voucher &&
                                                            <TextField name="voucher_code"  size="small" variant="outlined" onChange={handleChange}
                                                                sx={{width: 100}}  
                                                                inputProps={{ maxLength: 6 }} 
                                                                error={input.error && (input.with_voucher && (input.voucher_code.trim() === "" || !input.voucher_valid) )}
                                                                value={input.voucher_code}
                                                                helperText={input.error && !input.voucher_valid && 'Invalid code'}
                                                            />
                                                    }
                                                </Stack>
                                        }
                                        <Stack>
                                            <FormControl>
                                                <Typography variant="subtitle1" fontWeight={600}>Pay thru:</Typography>
                                                <RadioGroup name="payment_method" row onChange={handleChange} value={input.payment_method}>
                                                    <FormControlLabel value="GCSH" control={<Radio size="small"/>} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} disabled={isAvailed}
                                                        label={
                                                            <Box display="flex" alignItems="center" gap={1}>
                                                                <img src={Gcash} alt="GCash" width={24} height={24} />
                                                                <Typography>Gcash</Typography>
                                                            </Box>
                                                        }
                                                    />
                                                    <FormControlLabel value="UBPB" control={<Radio size="small"/>} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} disabled={isAvailed}
                                                        label={
                                                            <Box display="flex" alignItems="center" gap={1}>
                                                                <img src={Ub} alt="Unionbank" width={22} height={22} />
                                                                <Typography>Unionbank Online Banking</Typography>
                                                            </Box>
                                                        }
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </Stack>
                                        <Divider />
                                        <Stack gap="4px">
                                            <Stack direction="row" justifyContent="space-between">
                                                <Typography sx={{fontSize: "16px", fontWeight: "400", color: '#5B6167',}}>Regular Fee:</Typography>
                                                {/* {computationDetails().training_fee} */}
                                                <Typography fontSize={16} fontWeight={600} sx={{ color: '#CF2A27' }}>₱ {info.data.regular_price}</Typography>
                                            </Stack>
                                            {
                                                (input.voucher_valid || info.data.voucher_code === "") &&
                                                    <>
                                                        <Stack direction="row" justifyContent="space-between">
                                                            <Typography sx={{fontSize: "16px", fontWeight: "400", color: '#5B6167',}}>Discount:</Typography>
                                                            {/* {computationDetails().training_fee} */}
                                                            <Typography fontSize={16} fontWeight={600} sx={{ color: '#CF2A27' }}>₱ {computationAmount().discount_amount}</Typography>
                                                        </Stack>
                                                        <Divider />
                                                        <Stack direction="row" justifyContent="space-between">
                                                            <Typography sx={{fontSize: "16px", fontWeight: "400", color: '#5B6167',}}>Discount Price:</Typography>
                                                            {/* {computationDetails().training_fee} */}
                                                            <Typography fontSize={16} fontWeight={600} sx={{ color: '#CF2A27' }}>₱ {computationAmount().membership_fee}</Typography>
                                                        </Stack>
                                                    </>
                                            }
                                        </Stack>
                                    </>
                            }
                        </Stack>
                    </Box>
                </Box>
                <Box p="1rem" borderTop="1px solid #0000001f" display="flex" justifyContent="center">
                    <Button variant="contained" fullWidth disableElevation onClick={handlePay} disabled={isAvailed}>
                        {
                            isAvailed ?
                                'Already Registered'
                            :
                                info.data.fee_type === 2 ? 'Pay' : 'Join for Free'
                        }
                    </Button>
                </Box>
            </Dialog>
            <Dialog open={input.confirmation} >
                <DialogTitle sx={{ fontSize: '18px', fontWeight: 600 }}>
                    Confirm Save
                </DialogTitle>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>
                        Are you sure you want to save this membership?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' onClick={() => setInput((p) => ( {...p, confirmation : false} ))}
                        disabled={input.btnLoader}    
                    >
                        Cancel
                    </Button>
                    <Button variant="contained" onClick={() => handleConfirmation('logged_in')} disabled={input.btnLoader}>
                        {
                            input.btnLoader ? <CircularProgress size={22} /> : 'Save'
                        }
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}